import { capitalizeFirstLetter } from "./capitalizeFirstLetter";

const getTitleFromSlug = (slug: string) => {
  const titleFromSlug = slug.replaceAll("-", " ");
  return capitalizeFirstLetter(titleFromSlug);
};

export { getTitleFromSlug };
